import type {
  AchievementsResponse,
  KeyDocument,
  Locale,
  PrivacyUpdate,
  PublicAward,
  PublicInvite,
  PublicPrivacy,
  ShareChannel,
  ShareTarget,
} from '@tg/shared';
import { api, type RequestOptions } from '@/api/client';

const ch = (channel: ShareChannel | null) => (channel ? `?c=${channel}` : '');
/** public award: the card pictures in the page language (`locale`), the channel counted once */
const pq = (channel: ShareChannel | null, locale: Locale) => `?locale=${locale}${channel ? `&c=${channel}` : ''}`;

/** apps/server/src/share + achievements routes (contracts: @tg/shared achievements.ts / share.ts). */
export const shareApi = {
  award: (id: string, locale: Locale) => api.post<ShareTarget>(`/api/share/awards/${encodeURIComponent(id)}`, { locale }),
  unshare: (id: string) => api.post<{ ok: true }>(`/api/share/awards/${encodeURIComponent(id)}/unshare`),
  moment: (betId: string, locale: Locale) => api.post<ShareTarget>('/api/share/moments', { betId, locale }),
  invite: (locale: Locale, o?: RequestOptions) => api.get<ShareTarget>(`/api/share/invite?locale=${locale}`, o),
  publicAward: (id: string, channel: ShareChannel | null, locale: Locale, o?: RequestOptions) =>
    api.get<PublicAward>(`/api/public/awards/${encodeURIComponent(id)}${pq(channel, locale)}`, o),
  publicInvite: (code: string, channel: ShareChannel | null, o?: RequestOptions) =>
    api.get<PublicInvite>(`/api/public/invites/${encodeURIComponent(code)}${ch(channel)}`, o),
  keys: (o?: RequestOptions) => api.get<KeyDocument>('/.well-known/tg-achievement-keys.json', o),
  achievements: (o?: RequestOptions) => api.get<AchievementsResponse>('/api/me/achievements', o),
  /** the achievements section was opened: these awards are no longer new on the «Profile» menu badge */
  seen: (ids: string[]) => api.post<{ marked: number }>('/api/me/achievements/seen', { ids }),
  privacy: (p: PrivacyUpdate) => api.patch<PublicPrivacy>('/api/me/privacy', p),
};
